function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M65.3684 96.1423C87.4679 84.7968 96.2344 57.589 84.9489 35.372C73.6634 13.155 46.5995 4.34192 24.5 15.6874C2.40053 27.0329 -6.36596 54.2407 4.91953 76.4577C16.205 98.6747 43.2689 107.488 65.3684 96.1423Z",
  fill: "#FFE06D"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M57.2705 34.7976L46.6647 25.0077C45.7005 24.0384 44.0614 24.0384 43.0973 25.0077L32.5879 34.7976H57.2705Z",
  fill: "#DDAE00"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1054 34.7976H22.7539V53.8926L37.2164 64.9425H52.643L67.1054 53.8926V34.7976Z",
  fill: "#F8F8FD"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M56.4996 43.7149H33.3597C32.7812 43.7149 32.3955 43.3272 32.3955 42.7457C32.3955 42.1641 32.7812 41.7764 33.3597 41.7764H56.4996C57.0781 41.7764 57.4638 42.1641 57.4638 42.7457C57.4638 43.3272 56.9817 43.7149 56.4996 43.7149Z",
  fill: "#ABB4C6"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M56.4996 49.0461H33.3597C32.7812 49.0461 32.3955 48.6584 32.3955 48.0768C32.3955 47.4953 32.7812 47.1075 33.3597 47.1075H56.4996C57.0781 47.1075 57.4638 47.4953 57.4638 48.0768C57.4638 48.6584 56.9817 49.0461 56.4996 49.0461Z",
  fill: "#ABB4C6"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M56.4996 54.3772H33.3597C32.7812 54.3772 32.3955 53.9895 32.3955 53.4079C32.3955 52.8263 32.7812 52.4386 33.3597 52.4386H56.4996C57.0781 52.4386 57.4638 52.8263 57.4638 53.4079C57.4638 53.9895 56.9817 54.3772 56.4996 54.3772Z",
  fill: "#ABB4C6"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.23,
  d: "M56.4996 59.7084H33.3597C32.7812 59.7084 32.3955 59.3206 32.3955 58.7391C32.3955 58.1575 32.7812 57.7698 33.3597 57.7698H56.4996C57.0781 57.7698 57.4638 58.1575 57.4638 58.7391C57.4638 59.3206 56.9817 59.7084 56.4996 59.7084Z",
  fill: "#ABB4C6"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M22.8502 53.9895L22.7537 53.8926V44.0059L16.9688 49.4339L22.8502 53.9895Z",
  fill: "#DDAE00"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M67.1049 44.0059V53.8926L66.9121 53.9895L72.8899 49.4339L67.1049 44.0059Z",
  fill: "#DDAE00"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9688 80.4511H17.0652H72.4082H72.6974H72.8903L52.6428 64.9425H37.2162L16.9688 80.4511Z",
  fill: "#E6B500"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9688 80.4511V49.4338L37.2162 64.9425L16.9688 80.4511Z",
  fill: "#FFE06D"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M72.89 80.4511V49.4338L52.6426 64.9425L72.89 80.4511Z",
  fill: "#FFE06D"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M98.9238 17.6411C99.5987 17.1565 113.001 6.39734 113.001 6.39734L107.119 23.3599L98.9238 17.6411Z",
  fill: "#94F1DB"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M86.0039 14.2486C86.0039 14.2486 93.1387 15.9933 93.2351 15.8964C93.428 15.7995 113 6.39734 113 6.39734L86.0039 14.2486Z",
  fill: "#94F1DB"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M93.2354 15.8964L94.9708 23.6507L98.9239 17.6411L113.001 6.39734L93.2354 15.8964Z",
  fill: "#6FCFBE"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M94.9707 23.6507L100.274 18.6104L98.9238 17.6411L94.9707 23.6507Z",
  fill: "#3F8084"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M69.2266 30.3388C70.5764 29.7572 72.6976 29.5634 75.108 31.9866C79.2539 36.0576 75.108 45.3628 82.1464 45.1689C87.16 45.072 87.6421 34.7975 84.7496 34.7975C81.7607 34.7975 83.5926 39.9348 86.6779 39.9348C96.1267 40.0317 92.0773 30.5326 92.0773 30.5326C92.0773 30.5326 91.4023 26.8493 92.5593 25.0077",
  stroke: "#7784A0",
  strokeOpacity: 0.26,
  strokeWidth: 0.8975,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M33.6494 2.03552V6.68811",
  stroke: "#E7BC1D",
  strokeWidth: 1.5658,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M35.9629 4.36182H31.335",
  stroke: "#E7BC1D",
  strokeWidth: 1.5658,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M6.16992 21.4213V25.0076",
  stroke: "#E7BC1D",
  strokeWidth: 1.1754,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M7.90556 23.166H4.43457",
  stroke: "#E7BC1D",
  strokeWidth: 1.1754,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M73.6621 14.1516V17.6411",
  stroke: "#E7BC1D",
  strokeWidth: 1.1754,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M75.3975 15.8964H71.8301",
  stroke: "#E7BC1D",
  strokeWidth: 1.1754,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M69.9014 8.62671V12.6008",
  stroke: "#F8F8FD",
  strokeWidth: 1.3432,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M71.83 10.5653H67.877",
  stroke: "#F8F8FD",
  strokeWidth: 1.3432,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M4.04889 14.8302C5.22038 14.8302 6.17006 13.8755 6.17006 12.6977C6.17006 11.52 5.22038 10.5653 4.04889 10.5653C2.87741 10.5653 1.92773 11.52 1.92773 12.6977C1.92773 13.8755 2.87741 14.8302 4.04889 14.8302Z",
  fill: "#FFE06D"
});
var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M61.8023 2.22937C61.8023 3.39251 60.8382 4.45873 59.5848 4.45873C58.4278 4.45873 57.3672 3.48944 57.3672 2.22937C57.3672 0.96929 58.3314 0 59.5848 0C60.8382 0 61.8023 0.96929 61.8023 2.22937Z",
  fill: "#E7BC1D"
});
var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1149 9.98369C21.9669 9.98369 22.6576 9.28934 22.6576 8.43282C22.6576 7.5763 21.9669 6.88196 21.1149 6.88196C20.2629 6.88196 19.5723 7.5763 19.5723 8.43282C19.5723 9.28934 20.2629 9.98369 21.1149 9.98369Z",
  fill: "#F8F8FD"
});
function SvgForgotPasswordImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 101,
    viewBox: "0 0 113 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordImage);
export default __webpack_public_path__ + "static/media/forgot-password-image.461a7c6c.svg";
export { ForwardRef as ReactComponent };